export default __webpack_public_path__ + "static/media/icons8-zip.97605ea1.svg";